<template>
  <v-icon small v-text="status.icon" :color="status.color" class="mx-2" />
</template>

<script>
export default {
  name: 'EntityStatus',
  props: {
    report: Object
  },
  computed: {
    status() {
      let done = {
        icon: this.$vuetify.icons.values.stateSuccess,
        color: 'success lighten-1'
      }
      let pending = {
        icon: this.$vuetify.icons.values.statePending,
        color: 'warning lighten-1'
      }
      let failed = {
        icon: this.$vuetify.icons.values.stateFailure,
        color: 'error lighten-2'
      }
      switch (this.report.status) {
        case 'PENDING':
          return pending
        case 'FAILED':
          return failed
        default:
          return done
      }
    }
  }
}
</script>
